/*  */
import React, { createContext, useContext, useState, FC, useRef } from 'react';
import playerService from '../../services/players';
import { useLanguage } from '../LanguageContext';
import { ContextProps, CreatePlayer, ProviderProps } from './types';
import { PlayerType } from '../../types/entities';

export const PlayerContext = createContext<ContextProps>({
  player: undefined,
  playerRef: { current: undefined },
  isLoading: false,
  createPlayer: async () => {},
  setPlayer: () => {},
});

export const PlayerProvider: FC<ProviderProps> = ({ children }: ProviderProps) => {
  const [player, setPlayer] = useState<PlayerType>();
  const playerRef = useRef<PlayerType>();
  const [isLoading, setLoading] = useState(false);
  const { languageSelector } = useLanguage();

  const createPlayer = async (playerData: CreatePlayer) => {
    try {
      setLoading(true);
      const res = await playerService.create(playerData, languageSelector);
      const newPlayer = { ...playerData, documentId: res.data.data.documentId };
      setPlayer(newPlayer);
      playerRef.current = newPlayer;
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <PlayerContext.Provider
      value={{
        player,
        playerRef,
        setPlayer,
        createPlayer,
        isLoading,
      }}>
      {children}
    </PlayerContext.Provider>
  );
};

export default function usePlayerContext(): ContextProps {
  return useContext(PlayerContext);
}
